// extracted by mini-css-extract-plugin
module.exports = {"heating-consistency":"heating-consistency_heating-consistency__paH0F","heading":"heating-consistency_heading__qf56n"};